const phone = "1-763-332-0919";
const email = "chase@context-coding.com";


module.exports = {
  phone,
  email,
};
